import { Box } from "@mui/material";
import { LeadsManagementData } from "../hooks/useLeadsManagementData";
import LeadsFilterCard from "./LeadsFilterCard";
import LeadsStatusTabs from "./LeadsStatusTabs";
import LeadsTable from "./LeadsTable";
import LeadsSkeleton from "./LeadsSkeleton";
import LeadsBulkActionBar from "./LeadsBulkActionBar";
import LeadDetailDrawer from "./LeadDetailDrawer";
import ReportLeadsModal from "./ReportLeadsModal";
import RejectLeadsModal from "./RejectLeadsModal";
import BrandMatchModal from "./BrandMatchModal";

interface LeadsProps {
  data: LeadsManagementData;
}

export default function Leads({ data }: LeadsProps) {
  return (
    <Box>
      <LeadsFilterCard data={data} />
      <LeadsStatusTabs data={data} />

      {data.isLoading ? (
        <LeadsSkeleton />
      ) : (
        <LeadsTable data={data} />
      )}

      <LeadsBulkActionBar data={data} />
      <LeadDetailDrawer data={data} />
      <ReportLeadsModal data={data} />
      <RejectLeadsModal data={data} />
      <BrandMatchModal data={data} />
    </Box>
  );
}
